var _defs, _g, _g2, _g3, _b, _b2, _text, _image, _g4, _g5, _g6, _g7, _text2, _image2, _g8, _g9, _g10, _text3, _g11, _g12, _g13, _g14, _text4, _g15, _g16, _g17, _g18, _g19, _text5, _g20, _g21, _g22, _g23, _text6, _g24, _g25, _g26, _g27, _text7, _g28, _g29, _g30, _g31, _text8, _g32, _g33, _g34, _g35, _text9, _g36, _g37, _g38, _g39, _text10, _g40, _g41, _g42, _g43, _text11, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFamilyTreeMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1220,
    height: 1182,
    viewBox: "-0.5 -0.5 1220 1182",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "mx-clippath-inset-0-0-0-45-0-round-50-1",
    clipPathUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1,
    height: 0.9955,
    rx: 0.5,
    ry: 0.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "mx-clippath-inset-1-46-0-1-46-0-round-50-1",
    clipPathUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0.0146,
    width: 1,
    height: 0.9708000000000001,
    rx: 0.5,
    ry: 0.5
  })), /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "@import url(https://fonts.googleapis.com/css2?family=Noto+Sans:wght@400;500);&#xa;"), /*#__PURE__*/React.createElement("filter", {
    id: "dropShadow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: 1.7,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feOffset", {
    in: "blur",
    dx: 3,
    dy: 3,
    result: "offsetBlur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#3D4574",
    floodOpacity: 0.4,
    result: "offsetColor"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "offsetColor",
    in2: "offsetBlur",
    operator: "in",
    result: "offsetBlur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "offsetBlur"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#dropShadow)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2.01,
    y: 2,
    width: 290.38,
    height: 150.57,
    rx: 22.59,
    ry: 22.59,
    fill: "#fcf3ea",
    stroke: "#fc906c",
    strokeWidth: 5,
    pointerEvents: "all"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 120.31,
    y: 34.26,
    width: 172.08,
    height: 86.04,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 77,
      marginLeft: 206
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #fc906c; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 23,
      fontFamily: "sans-serif",
      color: "rgb(252, 144, 108)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 28
    }
  }, _b || (_b = /*#__PURE__*/React.createElement("b", null, "Ethlyn"))), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 28
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 28
    }
  }, _b2 || (_b2 = /*#__PURE__*/React.createElement("b", null, "George")))))))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 206,
    y: 84,
    fill: "#fc906c",
    fontFamily: "sans-serif",
    fontSize: "23px",
    textAnchor: "middle"
  }, "Ethlyn..."))))), /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "drop-shadow(rgba(0, 0, 0, 0.25) 2px 3px 2px)"
    }
  }, _image || (_image = /*#__PURE__*/React.createElement("image", {
    x: 11.5,
    y: 21.279999999999745,
    width: 100.4524886877828,
    height: 111.50175791059769,
    xlinkHref: "data:image/jpeg;base64,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",
    preserveAspectRatio: "none",
    clipPath: "url(#mx-clippath-inset-0-0-0-45-0-round-50-1)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2.01,
    y: 321.57,
    width: 290.38,
    height: 150.57,
    rx: 22.59,
    ry: 22.59,
    fill: "#fcf3ea",
    stroke: "#fc906c",
    strokeWidth: 5,
    pointerEvents: "all"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 147.33 321.57 L 147.33 280.67 L 147.2 239",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2.01,
    y: 321.57,
    width: 290.38,
    height: 150.57,
    rx: 22.59,
    ry: 22.59,
    fill: "none",
    stroke: "#fc906c",
    strokeWidth: 5,
    strokeDasharray: "40 40",
    pointerEvents: "none"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 120.31,
    y: 353.84,
    width: 172.08,
    height: 86.04,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 397,
      marginLeft: 206
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #fc906c; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 23,
      fontFamily: "sans-serif",
      color: "rgb(252, 144, 108)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 28
    }
  }, "Roosevelt"), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 28
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 28
    }
  }, "George")))))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 206,
    y: 404,
    fill: "#fc906c",
    fontFamily: "sans-serif",
    fontSize: "23px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "Roosevelt..."))))), /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "drop-shadow(rgba(0, 0, 0, 0.25) 2px 3px 2px)"
    }
  }, _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    x: 9.80999999999949,
    y: 339.6956942727646,
    width: 110,
    height: 113.30861145447052,
    xlinkHref: "data:image/jpeg;base64,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",
    preserveAspectRatio: "none",
    clipPath: "url(#mx-clippath-inset-1-46-0-1-46-0-round-50-1)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 472.01,
    y: 162,
    width: 290.38,
    height: 150.57,
    rx: 22.59,
    ry: 22.59,
    fill: "rgb(255, 255, 255)",
    stroke: "#000000",
    pointerEvents: "all"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 590.31,
    y: 194.26,
    width: 172.08,
    height: 86.04,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 237,
      marginLeft: 676
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 23,
      fontFamily: "sans-serif",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 28
    }
  }, "Janice"), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 28
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 28
    }
  }, "George")), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 28
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 28
    }
  }, "Harris")))))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 676,
    y: 244,
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: "23px",
    textAnchor: "middle"
  }, "Janice..."))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 535.31,
    cy: 237.28,
    rx: 55.00000000000001,
    ry: 55.00000000000001,
    fill: "#e6e6e6",
    stroke: "#000000",
    strokeWidth: 2,
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 491.31 270.28 C 494.32 262.87 507.01 257.43 522.11 257.08 C 523.08 257.24 524.06 256.97 524.81 256.33 C 525.55 255.69 525.97 254.76 525.96 253.78 C 526.72 246.76 524.06 239.8 518.81 235.08 C 517.47 235.08 516.39 232.37 516.39 229.03 C 516.39 225.69 517.47 222.98 518.81 222.98 C 518.19 218.13 519.62 213.24 522.75 209.49 C 525.88 205.73 530.43 203.45 535.31 203.18 C 540.19 203.45 544.74 205.73 547.87 209.49 C 551 213.24 552.43 218.13 551.81 222.98 C 553.15 222.98 554.23 225.69 554.23 229.03 C 554.23 232.37 553.15 235.08 551.81 235.08 C 546.56 239.8 543.9 246.76 544.66 253.78 C 544.65 254.76 545.07 255.69 545.81 256.33 C 546.56 256.97 547.54 257.24 548.51 257.08 C 563.61 257.43 576.3 262.87 579.31 270.28",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 472.01,
    y: 402,
    width: 290.38,
    height: 150.57,
    rx: 22.59,
    ry: 22.59,
    fill: "rgb(255, 255, 255)",
    stroke: "#000000",
    pointerEvents: "all"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 590.31,
    y: 434.26,
    width: 172.08,
    height: 86.04,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 477,
      marginLeft: 676
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 23,
      fontFamily: "sans-serif",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 28
    }
  }, "Gregory"), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 28
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 28
    }
  }, "George")))))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 676,
    y: 484,
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: "23px",
    textAnchor: "middle"
  }, "Gregory..."))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 472.01 477.28 L 372 477.33 L 372 237",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 535.32,
    cy: 477.28,
    rx: 55.00000000000001,
    ry: 55.00000000000001,
    fill: "#e6e6e6",
    stroke: "#000000",
    strokeWidth: 2,
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 491.32 510.28 C 494.33 502.87 507.02 497.43 522.12 497.08 C 523.09 497.24 524.07 496.97 524.82 496.33 C 525.56 495.69 525.98 494.76 525.97 493.78 C 526.73 486.76 524.07 479.8 518.82 475.08 C 517.48 475.08 516.4 472.37 516.4 469.03 C 516.4 465.69 517.48 462.98 518.82 462.98 C 518.2 458.13 519.63 453.24 522.76 449.49 C 525.89 445.73 530.44 443.45 535.32 443.18 C 540.2 443.45 544.75 445.73 547.88 449.49 C 551.01 453.24 552.44 458.13 551.82 462.98 C 553.16 462.98 554.24 465.69 554.24 469.03 C 554.24 472.37 553.16 475.08 551.82 475.08 C 546.57 479.8 543.91 486.76 544.67 493.78 C 544.66 494.76 545.08 495.69 545.82 496.33 C 546.57 496.97 547.55 497.24 548.52 497.08 C 563.62 497.43 576.31 502.87 579.32 510.28",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null)), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 472.02,
    y: 827,
    width: 290.39,
    height: 150.57,
    rx: 22.59,
    ry: 22.59,
    fill: "rgb(255, 255, 255)",
    stroke: "#000000",
    pointerEvents: "all"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 590.32,
    y: 859.26,
    width: 172.08,
    height: 86.04,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 902,
      marginLeft: 676
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 23,
      fontFamily: "sans-serif",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 28
    }
  }, "Michael"), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 28
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 28
    }
  }, "George")))))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 676,
    y: 909,
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: "23px",
    textAnchor: "middle"
  }, "Michael..."))))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 535.32,
    cy: 902.28,
    rx: 55.00000000000001,
    ry: 55.00000000000001,
    fill: "#e6e6e6",
    stroke: "#000000",
    strokeWidth: 2,
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 491.32 935.28 C 494.33 927.87 507.02 922.43 522.12 922.08 C 523.09 922.24 524.07 921.97 524.82 921.33 C 525.56 920.69 525.98 919.76 525.97 918.78 C 526.73 911.76 524.07 904.8 518.82 900.08 C 517.48 900.08 516.4 897.37 516.4 894.03 C 516.4 890.69 517.48 887.98 518.82 887.98 C 518.2 883.13 519.63 878.24 522.76 874.49 C 525.89 870.73 530.44 868.45 535.32 868.18 C 540.2 868.45 544.75 870.73 547.88 874.49 C 551.01 878.24 552.44 883.13 551.82 887.98 C 553.16 887.98 554.24 890.69 554.24 894.03 C 554.24 897.37 553.16 900.08 551.82 900.08 C 546.57 904.8 543.91 911.76 544.67 918.78 C 544.66 919.76 545.08 920.69 545.82 921.33 C 546.57 921.97 547.55 922.24 548.52 922.08 C 563.62 922.43 576.31 927.87 579.32 935.28",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null)), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 922.01,
    y: 162,
    width: 290.38,
    height: 150.57,
    rx: 22.59,
    ry: 22.59,
    fill: "rgb(255, 255, 255)",
    stroke: "#000000",
    strokeDasharray: "8 8",
    pointerEvents: "all"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1040.32,
    y: 194.26,
    width: 172.08,
    height: 86.04,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 237,
      marginLeft: 1126
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #A6A6A6; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 23,
      fontFamily: "sans-serif",
      color: "rgb(166, 166, 166)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 28
    }
  }, "Sheldon"), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 28
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 28
    }
  }, "Harris")))))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 1126,
    y: 244,
    fill: "#A6A6A6",
    fontFamily: "sans-serif",
    fontSize: "23px",
    textAnchor: "middle"
  }, "Sheldon..."))))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 985.32,
    cy: 237.29,
    rx: 55.00000000000001,
    ry: 55.00000000000001,
    fill: "#e6e6e6",
    stroke: "#b0b0b0",
    strokeWidth: 2,
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 941.32 270.29 C 944.33 262.88 957.02 257.44 972.12 257.09 C 973.09 257.25 974.07 256.98 974.82 256.34 C 975.56 255.7 975.98 254.77 975.97 253.79 C 976.73 246.77 974.07 239.81 968.82 235.09 C 967.48 235.09 966.4 232.38 966.4 229.04 C 966.4 225.7 967.48 222.99 968.82 222.99 C 968.2 218.14 969.63 213.25 972.76 209.5 C 975.89 205.74 980.44 203.46 985.32 203.19 C 990.2 203.46 994.75 205.74 997.88 209.5 C 1001.01 213.25 1002.44 218.14 1001.82 222.99 C 1003.16 222.99 1004.24 225.7 1004.24 229.04 C 1004.24 232.38 1003.16 235.09 1001.82 235.09 C 996.57 239.81 993.91 246.77 994.67 253.79 C 994.66 254.77 995.08 255.7 995.82 256.34 C 996.57 256.98 997.55 257.25 998.52 257.09 C 1013.62 257.44 1026.31 262.88 1029.32 270.29",
    fill: "none",
    stroke: "#b0b0b0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null)), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 922.01,
    y: 402,
    width: 290.38,
    height: 150.57,
    rx: 22.59,
    ry: 22.59,
    fill: "rgb(255, 255, 255)",
    stroke: "#000000",
    strokeDasharray: "8 8",
    pointerEvents: "all"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1040.32,
    y: 434.26,
    width: 172.08,
    height: 86.04,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 477,
      marginLeft: 1126
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #A6A6A6; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 23,
      fontFamily: "sans-serif",
      color: "rgb(166, 166, 166)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 28
    }
  }, "Eugenie"), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 28
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 28
    }
  }, "George")))))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 1126,
    y: 484,
    fill: "#A6A6A6",
    fontFamily: "sans-serif",
    fontSize: "23px",
    textAnchor: "middle"
  }, "Eugenie..."))))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 985.32,
    cy: 477.29,
    rx: 55.00000000000001,
    ry: 55.00000000000001,
    fill: "#e6e6e6",
    stroke: "#b0b0b0",
    strokeWidth: 2,
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 941.32 510.29 C 944.33 502.88 957.02 497.44 972.12 497.09 C 973.09 497.25 974.07 496.98 974.82 496.34 C 975.56 495.7 975.98 494.77 975.97 493.79 C 976.73 486.77 974.07 479.81 968.82 475.09 C 967.48 475.09 966.4 472.38 966.4 469.04 C 966.4 465.7 967.48 462.99 968.82 462.99 C 968.2 458.14 969.63 453.25 972.76 449.5 C 975.89 445.74 980.44 443.46 985.32 443.19 C 990.2 443.46 994.75 445.74 997.88 449.5 C 1001.01 453.25 1002.44 458.14 1001.82 462.99 C 1003.16 462.99 1004.24 465.7 1004.24 469.04 C 1004.24 472.38 1003.16 475.09 1001.82 475.09 C 996.57 479.81 993.91 486.77 994.67 493.79 C 994.66 494.77 995.08 495.7 995.82 496.34 C 996.57 496.98 997.55 497.25 998.52 497.09 C 1013.62 497.44 1026.31 502.88 1029.32 510.29",
    fill: "none",
    stroke: "#b0b0b0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", null)), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 922.01,
    y: 827,
    width: 290.38,
    height: 150.57,
    rx: 22.59,
    ry: 22.59,
    fill: "rgb(255, 255, 255)",
    stroke: "#000000",
    strokeDasharray: "8 8",
    pointerEvents: "all"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1040.32,
    y: 859.26,
    width: 172.08,
    height: 86.04,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 902,
      marginLeft: 1126
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #A6A6A6; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 23,
      fontFamily: "sans-serif",
      color: "rgb(166, 166, 166)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 28
    }
  }, "Aquilina"), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 28
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 28
    }
  }, "George")))))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 1126,
    y: 909,
    fill: "#A6A6A6",
    fontFamily: "sans-serif",
    fontSize: "23px",
    textAnchor: "middle"
  }, "Aquilina..."))))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 985.32,
    cy: 902.29,
    rx: 55.00000000000001,
    ry: 55.00000000000001,
    fill: "#e6e6e6",
    stroke: "#b0b0b0",
    strokeWidth: 2,
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 941.32 935.29 C 944.33 927.88 957.02 922.44 972.12 922.09 C 973.09 922.25 974.07 921.98 974.82 921.34 C 975.56 920.7 975.98 919.77 975.97 918.79 C 976.73 911.77 974.07 904.81 968.82 900.09 C 967.48 900.09 966.4 897.38 966.4 894.04 C 966.4 890.7 967.48 887.99 968.82 887.99 C 968.2 883.14 969.63 878.25 972.76 874.5 C 975.89 870.74 980.44 868.46 985.32 868.19 C 990.2 868.46 994.75 870.74 997.88 874.5 C 1001.01 878.25 1002.44 883.14 1001.82 887.99 C 1003.16 887.99 1004.24 890.7 1004.24 894.04 C 1004.24 897.38 1003.16 900.09 1001.82 900.09 C 996.57 904.81 993.91 911.77 994.67 918.79 C 994.66 919.77 995.08 920.7 995.82 921.34 C 996.57 921.98 997.55 922.25 998.52 922.09 C 1013.62 922.44 1026.31 927.88 1029.32 935.29",
    fill: "none",
    stroke: "#b0b0b0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", null)), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 472.01,
    y: 1023.86,
    width: 290.38,
    height: 150.57,
    rx: 22.59,
    ry: 22.59,
    fill: "rgb(255, 255, 255)",
    stroke: "#000000",
    pointerEvents: "all"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 590.31,
    y: 1056.12,
    width: 172.08,
    height: 86.04,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 1099,
      marginLeft: 676
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 23,
      fontFamily: "sans-serif",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 28
    }
  }, "Imani"), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 28
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 28
    }
  }, "George")))))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 676,
    y: 1106,
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: "23px",
    textAnchor: "middle"
  }, "Imani..."))))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 535.31,
    cy: 1099.14,
    rx: 55.00000000000001,
    ry: 55.00000000000001,
    fill: "#dfe7f2",
    stroke: "#2056bf",
    strokeWidth: 2,
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 491.31 1132.14 C 494.32 1124.73 507.01 1119.29 522.11 1118.94 C 523.08 1119.1 524.06 1118.83 524.81 1118.19 C 525.55 1117.55 525.97 1116.62 525.96 1115.64 C 526.72 1108.62 524.06 1101.66 518.81 1096.94 C 517.47 1096.94 516.39 1094.23 516.39 1090.89 C 516.39 1087.55 517.47 1084.84 518.81 1084.84 C 518.19 1079.99 519.62 1075.1 522.75 1071.35 C 525.88 1067.59 530.43 1065.31 535.31 1065.04 C 540.19 1065.31 544.74 1067.59 547.87 1071.35 C 551 1075.1 552.43 1079.99 551.81 1084.84 C 553.15 1084.84 554.23 1087.55 554.23 1090.89 C 554.23 1094.23 553.15 1096.94 551.81 1096.94 C 546.56 1101.66 543.9 1108.62 544.66 1115.64 C 544.65 1116.62 545.07 1117.55 545.81 1118.19 C 546.56 1118.83 547.54 1119.1 548.51 1118.94 C 563.61 1119.29 576.3 1124.73 579.31 1132.14",
    fill: "none",
    stroke: "#2056bf",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", null)), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 922.01,
    y: 1023.86,
    width: 290.38,
    height: 150.57,
    rx: 22.59,
    ry: 22.59,
    fill: "rgb(255, 255, 255)",
    stroke: "#000000",
    pointerEvents: "all"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1040.32,
    y: 1056.12,
    width: 172.08,
    height: 86.04,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 1099,
      marginLeft: 1126
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 23,
      fontFamily: "sans-serif",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 28
    }
  }, "Jasmine"), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 28
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 28
    }
  }, "George")))))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 1126,
    y: 1106,
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: "23px",
    textAnchor: "middle"
  }, "Jasmine..."))))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 985.32,
    cy: 1099.15,
    rx: 55.00000000000001,
    ry: 55.00000000000001,
    fill: "#dfe7f2",
    stroke: "#2056bf",
    strokeWidth: 2,
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 941.32 1132.15 C 944.33 1124.74 957.02 1119.3 972.12 1118.95 C 973.09 1119.11 974.07 1118.84 974.82 1118.2 C 975.56 1117.56 975.98 1116.63 975.97 1115.65 C 976.73 1108.63 974.07 1101.67 968.82 1096.95 C 967.48 1096.95 966.4 1094.24 966.4 1090.9 C 966.4 1087.56 967.48 1084.85 968.82 1084.85 C 968.2 1080 969.63 1075.11 972.76 1071.36 C 975.89 1067.6 980.44 1065.32 985.32 1065.05 C 990.2 1065.32 994.75 1067.6 997.88 1071.36 C 1001.01 1075.11 1002.44 1080 1001.82 1084.85 C 1003.16 1084.85 1004.24 1087.56 1004.24 1090.9 C 1004.24 1094.24 1003.16 1096.95 1001.82 1096.95 C 996.57 1101.67 993.91 1108.63 994.67 1115.65 C 994.66 1116.63 995.08 1117.56 995.82 1118.2 C 996.57 1118.84 997.55 1119.11 998.52 1118.95 C 1013.62 1119.3 1026.31 1124.74 1029.32 1132.15",
    fill: "none",
    stroke: "#2056bf",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", null)), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 696.68,
    y: 598.86,
    width: 290.38,
    height: 150.57,
    rx: 22.59,
    ry: 22.59,
    fill: "rgb(255, 255, 255)",
    stroke: "#000000",
    pointerEvents: "all"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 814.98,
    y: 631.13,
    width: 172.08,
    height: 86.04,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 674,
      marginLeft: 901
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 23,
      fontFamily: "sans-serif",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 28
    }
  }, "Malik"), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 28
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 28
    }
  }, "George"))))))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 901,
    y: 681,
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: "23px",
    textAnchor: "middle"
  }, "Malik..."))))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 759.98,
    cy: 674.15,
    rx: 55.00000000000001,
    ry: 55.00000000000001,
    fill: "#dfe7f2",
    stroke: "#2056bf",
    strokeWidth: 2,
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 715.98 707.15 C 718.99 699.74 731.68 694.3 746.78 693.95 C 747.75 694.11 748.73 693.84 749.48 693.2 C 750.22 692.56 750.64 691.63 750.63 690.65 C 751.39 683.63 748.73 676.67 743.48 671.95 C 742.14 671.95 741.06 669.24 741.06 665.9 C 741.06 662.56 742.14 659.85 743.48 659.85 C 742.86 655 744.29 650.11 747.42 646.36 C 750.55 642.6 755.1 640.32 759.98 640.05 C 764.86 640.32 769.41 642.6 772.54 646.36 C 775.67 650.11 777.1 655 776.48 659.85 C 777.82 659.85 778.9 662.56 778.9 665.9 C 778.9 669.24 777.82 671.95 776.48 671.95 C 771.23 676.67 768.57 683.63 769.33 690.65 C 769.32 691.63 769.74 692.56 770.48 693.2 C 771.23 693.84 772.21 694.11 773.18 693.95 C 788.28 694.3 800.97 699.74 803.98 707.15",
    fill: "none",
    stroke: "#2056bf",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 147.33 152.57 L 147.33 193.67 L 147.19 235.02",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 472.01 237.33 L 307.67 237.33 L 142.01 236.86",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 851.87 237.29 L 922.01 237.29",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 762.39 477.28 L 922.01 477.28",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 842 598.86 L 842 477.33 L 922.01 477.28",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 472.02 902.28 L 372 902.33 L 372 477",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 762.4 902.33 L 842 902.33 L 842 1099 L 762.39 1099.14",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 922.01 902.33 L 842 902.33 L 842 1099 L 922.01 1099.14",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 147.2,
    cy: 237.29,
    rx: 10,
    ry: 10,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 762.39 237.28 L 831.87 237.28",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 841.87,
    cy: 237.28,
    rx: 10,
    ry: 10,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 841.87,
    cy: 477.29,
    rx: 10,
    ry: 10,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 841.87,
    cy: 902.29,
    rx: 10,
    ry: 10,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 841.87 257.29 C 843.35 255.62 851.82 246.07 857.12 240.1 C 861.87 234.76 861.77 226.96 857.45 222.13 C 853.14 217.29 846.16 217.31 841.87 222.17 C 837.58 217.31 830.6 217.29 826.29 222.12 C 821.97 226.96 821.87 234.75 826.61 240.1 C 831.91 246.07 840.39 255.62 841.87 257.29 Z",
    fill: "#ff0000",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 841.87 497.29 C 843.35 495.62 851.82 486.07 857.12 480.1 C 861.87 474.76 861.77 466.96 857.45 462.13 C 853.14 457.29 846.16 457.31 841.87 462.17 C 837.58 457.31 830.6 457.29 826.29 462.12 C 821.97 466.96 821.87 474.75 826.61 480.1 C 831.91 486.07 840.39 495.62 841.87 497.29 Z",
    fill: "#ff0000",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 841.87 922.29 C 843.35 920.62 851.82 911.07 857.12 905.1 C 861.87 899.76 861.77 891.96 857.45 887.13 C 853.14 882.29 846.16 882.31 841.87 887.17 C 837.58 882.31 830.6 882.29 826.29 887.12 C 821.97 891.96 821.87 899.75 826.61 905.1 C 831.91 911.07 840.39 920.62 841.87 922.29 Z",
    fill: "#ff0000",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 147.2 257.28 C 148.68 255.61 157.15 246.06 162.45 240.09 C 167.2 234.75 167.1 226.95 162.78 222.12 C 158.47 217.28 151.49 217.3 147.2 222.16 C 142.91 217.3 135.93 217.28 131.62 222.11 C 127.3 226.95 127.2 234.74 131.94 240.09 C 137.24 246.06 145.72 255.61 147.2 257.28 Z",
    fill: "#ff0000",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilyTreeMobile);
export default __webpack_public_path__ + "static/media/family-tree-mobile.78104e35159f7a00b733c99caaa8f312.svg";
export { ForwardRef as ReactComponent };